import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "data-section" };
const _hoisted_2 = { class: "table-wrapper" };
const _hoisted_3 = { class: "detail-table" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
    key: 0,
    class: "detail-row"
};
const _hoisted_6 = ["colspan"];
const _hoisted_7 = { class: "detail-content" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExpandableDataTable',
    props: {
        title: {},
        items: {},
        columns: {},
        expandedIndex: {}
    },
    emits: ["toggle-details"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function formatCellValue(item, column) {
            if (column.formatter) {
                return column.formatter(item);
            }
            // Handle nested properties with dot notation (e.g., "provider.name")
            const keys = column.key.split('.');
            let value = item;
            for (const key of keys) {
                value = value?.[key];
            }
            return value || '-';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.title) + " (" + _toDisplayString(_ctx.items.length) + ")", 1),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("table", _hoisted_3, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                                    return (_openBlock(), _createElementBlock("th", {
                                        key: column.key
                                    }, _toDisplayString(column.label), 1));
                                }), 128)),
                                _cache[0] || (_cache[0] = _createElementVNode("th", null, "Details", -1))
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    _createElementVNode("tr", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                                key: column.key
                                            }, _toDisplayString(formatCellValue(item, column)), 1));
                                        }), 128)),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("button", {
                                                class: "btn-expand",
                                                onClick: ($event) => (_ctx.$emit('toggle-details', index))
                                            }, _toDisplayString(_ctx.expandedIndex === index ? '−' : '+'), 9, _hoisted_4)
                                        ])
                                    ]),
                                    (_ctx.expandedIndex === index)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                                            _createElementVNode("td", {
                                                colspan: _ctx.columns.length + 1
                                            }, [
                                                _createElementVNode("div", _hoisted_7, [
                                                    _renderSlot(_ctx.$slots, "details", {
                                                        item: item,
                                                        index: index
                                                    })
                                                ])
                                            ], 8, _hoisted_6)
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 128))
                        ])
                    ])
                ])
            ]));
        };
    }
});
